import { MyFeatureFlags } from '@/helpers/my-account-helper'
import _ from 'lodash'

export function isFeatureOn(flag) {
  return isFeatureOnInFlagList(flag, MyFeatureFlags)
}

export function isFeatureOnInFlagList(flag, flagValues) {
  const flagValue = _.get(flagValues, flag, false)
  return flagValue !== null && flagValue.toString() === 'true'
}
